import {createAction} from 'redux-actions';
import {handleActions} from '../Utility/HandleActions';

//
// actionTypes
//
const INIT = 'DBM/System/INIT';

//
// Create actions
//
const init = createAction(INIT);

//
// Export actions
//
export const actions = {
    init
};

export const actionTypes = {
    INIT
};

//
// Export reducer
//
export const reducer = handleActions({
});
